import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { AnimatedLoader } from "./components/Loader/AnimatedLoader";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export const CONFIGURATOR_VIEWER = "/configurator/:modelId";

// const ConfiguratorViewer = lazy(() => import("./components/ConfiguratorViewer/ConfiguratorViewer"));
const ConfiguratorViewerV2 = lazy(() => import("./components/ConfiguratorViewer/ConfiguratorViewerV2"));
const Home = lazy(() => import("./components/Home/Home"));

const routeMapFunc = (
  { exact = true, path, Component, componentProps, routes },
  idx
) => {
  return (
    <Route
      path={path}
      exact={exact}
      element={<Component {...componentProps} />}
      key={idx}
    >
      {routes?.map(routeMapFunc)}
    </Route>
  );
};

export const routes = [
  { path: CONFIGURATOR_VIEWER, Component: ConfiguratorViewerV2, key: "viewer" },
  { path: '/', Component: ConfiguratorViewerV2, key: 'home'},
  { path: '/*', Component: ConfiguratorViewerV2, key: 'viewer'},
];

export const Routing = () => {
  return (
    <ErrorBoundary>
      {/* <Suspense fallback={<Loader zIndex={1000} loading={true} className="bg-white" position="fixed" />}> */}
      <Suspense
        fallback={
          <AnimatedLoader
            className="bg-white"
            zIndex={1000}
            position="absolute"
            top={0}
            backDrop={"rgba(255, 255, 255, 1"}
          />
        }
      >
         <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover
          limit={5}
        />
        <Routes>{routes.map(routeMapFunc)}</Routes>
      </Suspense>
    </ErrorBoundary>
  );
};
